import React from 'react';

const TrackerTitle = ({ children, date }) => (
  <div className="tracker-title">
    <h3>{children}</h3>
    {date && <h3 className='right'>{date}</h3>}
  </div>
)

export default TrackerTitle;




// WEBPACK FOOTER //
// ./src/components/TrackerTitle.js